var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"layout":"tabbed"}},[_c('page-header',{attrs:{"title":_vm.pageTitle,"breadcrumbs":_vm.breadcrumbs}},[_vm._t("actions",null,{"slot":"actions"})],2),_vm._v(" "),_c('page-tabs',{attrs:{"tabs":_vm.enabledTabs}},[_vm._t("default",null,{"slot":"router"})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029a1c0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/data-manager/pages/DataManagerLayout.vue
// module id = null
// module chunks = 